import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4e3f00a6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "master-crew-detail-page space-y-6" }
const _hoisted_2 = {
  key: 0,
  class: "flex justify-center items-center py-24"
}
const _hoisted_3 = {
  key: 1,
  class: "p-6 bg-white rounded-xl shadow-sm text-center"
}
const _hoisted_4 = { class: "text-neutral-500 mb-4" }
const _hoisted_5 = { class: "flex justify-between items-center pb-4 mb-6 border-b border-neutral-100" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex items-center gap-2" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "pi pi-users text-blue-600 text-xl" }),
  /*#__PURE__*/_createElementVNode("h3", { class: "text-xl font-bold text-neutral-800" }, "Informasi Umum")
], -1))
const _hoisted_7 = {
  key: 0,
  class: "badge-status-active"
}
const _hoisted_8 = {
  key: 1,
  class: "badge-status-inactive"
}
const _hoisted_9 = { class: "grid grid-cols-1 md:grid-cols-2 gap-6 items-center mb-8 pb-6 border-b border-neutral-100" }
const _hoisted_10 = { class: "flex items-center gap-4" }
const _hoisted_11 = ["src"]
const _hoisted_12 = {
  key: 1,
  class: "w-20 h-20 rounded-xl bg-neutral-200 flex items-center justify-center text-neutral-400"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-user text-3xl" }, null, -1))
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-xs text-neutral-500 mb-1" }, "Nama Lengkap", -1))
const _hoisted_16 = { class: "text-base font-bold text-neutral-800" }
const _hoisted_17 = { class: "md:pl-6 md:border-l md:border-neutral-200" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-xs text-neutral-500 mb-1" }, "User SSO", -1))
const _hoisted_19 = { class: "text-sm font-semibold text-neutral-800 break-all" }
const _hoisted_20 = { class: "grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-xs text-neutral-500 mb-1" }, "Kode Karyawan", -1))
const _hoisted_22 = { class: "pb-2 border-b border-neutral-200 text-sm font-semibold text-neutral-800" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-xs text-neutral-500 mb-1" }, "Kode Karyawan Lama", -1))
const _hoisted_24 = { class: "pb-2 border-b border-neutral-200 text-sm font-semibold text-neutral-800" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-xs text-neutral-500 mb-1" }, "Tempat Lahir", -1))
const _hoisted_26 = { class: "pb-2 border-b border-neutral-200 text-sm font-semibold text-neutral-800" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-xs text-neutral-500 mb-1" }, "Tanggal Lahir", -1))
const _hoisted_28 = { class: "pb-2 border-b border-neutral-200 text-sm font-semibold text-neutral-800 flex justify-between items-center" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-calendar text-neutral-400 text-sm" }, null, -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-xs text-neutral-500 mb-1" }, "Jenis Kelamin", -1))
const _hoisted_31 = { class: "pb-2 border-b border-neutral-200 text-sm font-semibold text-neutral-800" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-xs text-neutral-500 mb-1" }, "Tanggal masuk", -1))
const _hoisted_33 = { class: "pb-2 border-b border-neutral-200 text-sm font-semibold text-neutral-800 flex justify-between items-center" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-calendar text-neutral-400 text-sm" }, null, -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-xs text-neutral-500 mb-1" }, "Status Pernikahan", -1))
const _hoisted_36 = { class: "pb-2 border-b border-neutral-200 text-sm font-semibold text-neutral-800" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-xs text-neutral-500 mb-1" }, "Pendidikan Terakhir", -1))
const _hoisted_38 = { class: "pb-2 border-b border-neutral-200 text-sm font-semibold text-neutral-800" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-xs text-neutral-500 mb-1" }, "Nomor Telepon", -1))
const _hoisted_40 = { class: "pb-2 border-b border-neutral-200 text-sm font-semibold text-neutral-800" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-xs text-neutral-500 mb-1" }, "No. NFC Tag", -1))
const _hoisted_42 = { class: "pb-2 border-b border-neutral-200 text-sm font-semibold text-neutral-800 flex justify-between items-center" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M1.5 12.075C2.22067 12.222 2.88221 12.5776 3.40229 13.0977C3.92237 13.6178 4.27802 14.2793 4.425 15M1.5 9.0375C3.02309 9.2069 4.44321 9.88953 5.52684 10.9732C6.61047 12.0568 7.2931 13.4769 7.4625 15M1.5 6V4.5C1.5 4.10218 1.65804 3.72064 1.93934 3.43934C2.22064 3.15804 2.60218 3 3 3H15C15.3978 3 15.7794 3.15804 16.0607 3.43934C16.342 3.72064 16.5 4.10218 16.5 4.5V13.5C16.5 13.8978 16.342 14.2794 16.0607 14.5607C15.7794 14.842 15.3978 15 15 15H10.5",
    "stroke-width": "1.5",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    stroke: "#67748E"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M1.5 15H1.50797",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    stroke: "#67748E"
  })
], -1))
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-xs text-neutral-500 mb-1" }, "Jabatan (Divisi)", -1))
const _hoisted_45 = { class: "pb-2 border-b border-neutral-200 text-sm font-semibold text-neutral-800" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex items-center gap-2 pt-8 pb-4 mb-6 border-b border-neutral-100" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "pi pi-map-marker text-blue-600 text-xl" }),
  /*#__PURE__*/_createElementVNode("h3", { class: "text-xl font-bold text-neutral-800" }, "Alamat Karyawan")
], -1))
const _hoisted_47 = { class: "grid grid-cols-1 sm:grid-cols-3 gap-6 mb-6" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-xs text-neutral-500 mb-1" }, "Provinsi", -1))
const _hoisted_49 = { class: "pb-2 border-b border-neutral-200 text-sm font-semibold text-neutral-800" }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-xs text-neutral-500 mb-1" }, "Kota", -1))
const _hoisted_51 = { class: "pb-2 border-b border-neutral-200 text-sm font-semibold text-neutral-800" }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-xs text-neutral-500 mb-1" }, "Kode Pos", -1))
const _hoisted_53 = { class: "pb-2 border-b border-neutral-200 text-sm font-semibold text-neutral-800" }
const _hoisted_54 = { class: "mb-4" }
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-xs text-neutral-500 mb-1" }, "Alamat Domisili", -1))
const _hoisted_56 = { class: "pb-2 border-b border-neutral-200 text-sm font-semibold text-neutral-800" }
const _hoisted_57 = { class: "flex justify-end pt-8 pb-2" }

import { onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import Card from 'primevue/card'
import Button from 'primevue/button'
import ProgressSpinner from 'primevue/progressspinner'
import { useCrewDetail } from '@/composables/pages/master-setting/crew/useCrewDetail'


export default /*#__PURE__*/_defineComponent({
  __name: 'Detail',
  setup(__props) {

const route = useRoute()
const router = useRouter()

const {
  employee,
  isLoading,
  errorMessage,
  formatDate,
  formatGender,
  formatMaritalStatus,
  isActiveStatus,
  activePositionName,
  ssoDisplay,
  fetchEmployeeDetail
} = useCrewDetail()

const goBack = () => {
  router.push({ name: 'master-crew' })
}

const onImageError = (e: Event) => {
  const target = e.target as HTMLImageElement
  if (target) {
    target.style.display = 'none'
  }
}

onMounted(() => {
  const id = String(route.params.id || '')
  if (id) {
    fetchEmployeeDetail(id)
  } else {
    goBack()
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(isLoading))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_unref(ProgressSpinner), { style: {"width":"60px","height":"60px"} })
        ]))
      : (_unref(errorMessage))
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("p", _hoisted_4, _toDisplayString(_unref(errorMessage)), 1),
            _createVNode(_unref(Button), {
              label: "Kembali ke Master Kru",
              class: "btn-back-action",
              onClick: goBack
            })
          ]))
        : (_unref(employee))
          ? (_openBlock(), _createBlock(_unref(Card), {
              key: 2,
              class: "card-no-shadow"
            }, {
              content: _withCtx(() => [
                _createElementVNode("div", _hoisted_5, [
                  _hoisted_6,
                  _createElementVNode("div", null, [
                    (_unref(isActiveStatus))
                      ? (_openBlock(), _createElementBlock("span", _hoisted_7, " Aktif "))
                      : (_openBlock(), _createElementBlock("span", _hoisted_8, " Nonaktif "))
                  ])
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    (_unref(employee).imageUrl)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          src: _unref(employee).imageUrl,
                          alt: "Avatar",
                          class: "w-20 h-20 rounded-xl object-cover border border-neutral-200",
                          onError: onImageError
                        }, null, 40, _hoisted_11))
                      : (_openBlock(), _createElementBlock("div", _hoisted_12, _hoisted_14)),
                    _createElementVNode("div", null, [
                      _hoisted_15,
                      _createElementVNode("p", _hoisted_16, _toDisplayString(_unref(employee).fullName || '-'), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_17, [
                    _hoisted_18,
                    _createElementVNode("p", _hoisted_19, _toDisplayString(_unref(ssoDisplay)), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("div", null, [
                    _hoisted_21,
                    _createElementVNode("div", _hoisted_22, _toDisplayString(_unref(employee).personnelNumber || '-'), 1)
                  ]),
                  _createElementVNode("div", null, [
                    _hoisted_23,
                    _createElementVNode("div", _hoisted_24, _toDisplayString(_unref(employee).oldPersonnelNumber || '-'), 1)
                  ]),
                  _createElementVNode("div", null, [
                    _hoisted_25,
                    _createElementVNode("div", _hoisted_26, _toDisplayString(_unref(employee).birthPlace || '-'), 1)
                  ]),
                  _createElementVNode("div", null, [
                    _hoisted_27,
                    _createElementVNode("div", _hoisted_28, [
                      _createElementVNode("span", null, _toDisplayString(_unref(formatDate)(_unref(employee).birthDate)), 1),
                      _hoisted_29
                    ])
                  ]),
                  _createElementVNode("div", null, [
                    _hoisted_30,
                    _createElementVNode("div", _hoisted_31, _toDisplayString(_unref(formatGender)(_unref(employee).gender)), 1)
                  ]),
                  _createElementVNode("div", null, [
                    _hoisted_32,
                    _createElementVNode("div", _hoisted_33, [
                      _createElementVNode("span", null, _toDisplayString(_unref(formatDate)(_unref(employee).joinDate)), 1),
                      _hoisted_34
                    ])
                  ]),
                  _createElementVNode("div", null, [
                    _hoisted_35,
                    _createElementVNode("div", _hoisted_36, _toDisplayString(_unref(formatMaritalStatus)(_unref(employee).maritalStatus)), 1)
                  ]),
                  _createElementVNode("div", null, [
                    _hoisted_37,
                    _createElementVNode("div", _hoisted_38, _toDisplayString(_unref(employee).highestEducationLevel || '-'), 1)
                  ]),
                  _createElementVNode("div", null, [
                    _hoisted_39,
                    _createElementVNode("div", _hoisted_40, _toDisplayString(_unref(employee).phoneNumber || '-'), 1)
                  ]),
                  _createElementVNode("div", null, [
                    _hoisted_41,
                    _createElementVNode("div", _hoisted_42, [
                      _createElementVNode("span", null, _toDisplayString(_unref(employee).nfcCardIdentifier || '-'), 1),
                      _hoisted_43
                    ])
                  ]),
                  _createElementVNode("div", null, [
                    _hoisted_44,
                    _createElementVNode("div", _hoisted_45, _toDisplayString(_unref(activePositionName)), 1)
                  ])
                ]),
                _hoisted_46,
                _createElementVNode("div", _hoisted_47, [
                  _createElementVNode("div", null, [
                    _hoisted_48,
                    _createElementVNode("div", _hoisted_49, _toDisplayString(_unref(employee).province || '-'), 1)
                  ]),
                  _createElementVNode("div", null, [
                    _hoisted_50,
                    _createElementVNode("div", _hoisted_51, _toDisplayString(_unref(employee).city || '-'), 1)
                  ]),
                  _createElementVNode("div", null, [
                    _hoisted_52,
                    _createElementVNode("div", _hoisted_53, _toDisplayString(_unref(employee).postalCode || '-'), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_54, [
                  _hoisted_55,
                  _createElementVNode("div", _hoisted_56, _toDisplayString(_unref(employee).address || '-'), 1)
                ]),
                _createElementVNode("div", _hoisted_57, [
                  _createVNode(_unref(Button), {
                    label: "Kembali",
                    class: "btn-back-action",
                    onClick: goBack
                  })
                ])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
  ]))
}
}

})